// extracted by mini-css-extract-plugin
export default {"page":"styles_page__EibQ3","scrolled":"styles_scrolled__OFCgE","btn":"styles_btn__Fe7RC","icon":"styles_icon__Pv0sq","nav":"styles_nav__fObBP","nav_a":"styles_nav_a__z3oqy"};